module.exports = __webpack_public_path__ + "875ed72c9c2eaf3c32aeabb4f722eeef.png";